import * as React from 'react';

const SvgComponent = (props) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 50 50"
    {...props}>
    <defs>
      <linearGradient
        id="linear-gradient"
        x1={2.92}
        y1={48.32}
        x2={2.92}
        y2={48}
        gradientTransform="matrix(147.15 0 0 -143.83 -404.65 6951.48)"
        gradientUnits="userSpaceOnUse">
        <stop offset={0} stopColor="#5a5a5a" />
        <stop offset={1} stopColor="#272324" />
      </linearGradient>
      <style>{'.cls_yn2x_select_btn-4{isolation:isolate}'}</style>
    </defs>
    <g id="Component_23_2" data-name="Component 23 2">
      <g id="Component_14_27" data-name="Component 14 27">
        <g id="Union_10-2" data-name="Union 10-2">
          <path
            d="M33.21 48.2H16.63a3.91 3.91 0 0 1-3.9-3.89v-6.9h-8.1a3.37 3.37 0 0 1-3-1.7 2.86 2.86 0 0 1 .11-3l20.4-29.42a3.5 3.5 0 0 1 5.73 0L43 24.62l5.2 8.09a2.9 2.9 0 0 1 .11 3 3.38 3.38 0 0 1-3 1.69h-8.2v6.9a3.89 3.89 0 0 1-3.9 3.89Z"
            style={{
              fill: '#e6e3d5'
            }}
          />
          <path
            d="M33.21 47.42a3.11 3.11 0 0 0 3.12-3.11v-7.68h9a2.31 2.31 0 0 0 2.22-3.45l-5.19-8.1L27.23 3.73a2.71 2.71 0 0 0-4.44 0L2.41 33.17a2.31 2.31 0 0 0 2.22 3.46h8.88v7.68a3.12 3.12 0 0 0 3.12 3.11h16.58m0 1.56H16.63a4.59 4.59 0 0 1-3.31-1.37 5 5 0 0 1-1-1.48 4.74 4.74 0 0 1-.32-1.82v-6.12H4.63a4.31 4.31 0 0 1-2.18-.58A4 4 0 0 1 1 36.09a3.61 3.61 0 0 1 .14-3.76L21.49 2.86a4.28 4.28 0 0 1 7 0l15.2 21.34 5.22 8.12a3.63 3.63 0 0 1 .09 3.76 3.89 3.89 0 0 1-1.49 1.52 4.28 4.28 0 0 1-2.18.58h-7.44v6.13a4.56 4.56 0 0 1-.37 1.82 4.61 4.61 0 0 1-1 1.48A4.55 4.55 0 0 1 33.21 49Z"
            style={{
              fill: '#44c470'
            }}
          />
        </g>
        <path
          id="Union_11"
          data-name="Union 11"
          d="M16.63 47.42a3.12 3.12 0 0 1-3.12-3.11v-7.68H4.63a2.31 2.31 0 0 1-2.22-3.46L22.79 3.73a2.71 2.71 0 0 1 4.44 0L42.4 25.07l5.19 8.09a2.31 2.31 0 0 1-2.22 3.46h-9v7.69a3.11 3.11 0 0 1-3.12 3.11Z"
          style={{
            fill: 'url(#linear-gradient)'
          }}
        />
        <g id="_2" data-name={2} className="cls_yn2x_select_btn-4">
          <text
            transform="translate(15.27 34.83)"
            style={{
              fontFamily: 'JungleAdventurerRegular,Jungle Adventurer',
              fill: '#2a2729',
              fontSize: '22.45px',
              isolation: 'isolate'
            }}>
            {'2'}
          </text>
          <text
            transform="translate(15.27 34.83)"
            style={{
              fill: 'none',
              stroke: '#2a2728',
              strokeWidth: '2.18px',
              fontFamily: 'JungleAdventurerRegular,Jungle Adventurer',
              fontSize: '22.45px',
              isolation: 'isolate'
            }}>
            {'2'}
          </text>
        </g>
        <g id="x" className="cls_yn2x_select_btn-4">
          <text
            transform="translate(26.61 33.72)"
            style={{
              fontSize: '15.28px',
              fontFamily: 'JungleAdventurerRegular,Jungle Adventurer',
              fill: '#2a2729',
              isolation: 'isolate'
            }}>
            {'x'}
          </text>
          <text
            transform="translate(26.61 33.72)"
            style={{
              fontSize: '15.28px',
              fill: 'none',
              stroke: '#2a2728',
              strokeWidth: '2.18px',
              fontFamily: 'JungleAdventurerRegular,Jungle Adventurer',
              isolation: 'isolate'
            }}>
            {'x'}
          </text>
        </g>
        <g id="Group_4613" data-name="Group 4613">
          <text
            transform="translate(15.27 34.28)"
            style={{
              fontFamily: 'JungleAdventurerRegular,Jungle Adventurer',
              fontSize: '22.45px',
              isolation: 'isolate',
              fill: '#44c470'
            }}
            id="_2-2"
            data-name="2-2"
            className="cls_yn2x_select_btn-4">
            {'2'}
          </text>
          <text
            transform="translate(26.61 33.17)"
            style={{
              fontSize: '15.28px',
              fontFamily: 'JungleAdventurerRegular,Jungle Adventurer',
              isolation: 'isolate',
              fill: '#44c470'
            }}
            id="x-2"
            className="cls_yn2x_select_btn-4">
            {'x'}
          </text>
        </g>
      </g>
    </g>
  </svg>
);

export default SvgComponent;
